import { XCircle, CheckCircle2 } from "lucide-react";
import { Reveal, SectionTitle, Highlight } from "./Primitives";

const COLS = [
  {
    key: "before",
    title: "BEFORE This Masterclass",
    head: "bg-gradient-to-r from-red-600 to-red-500",
    bg: "bg-red-50/70",
    box: "border-red-300",
    Icon: XCircle,
    icon: "text-red-600",
    items: [
      "Salary comes in and disappears by month-end",
      "Saving, but the money isn't really growing",
      "Confused between FDs, mutual funds, insurance and loans",
      "No clear plan for retirement or your children's goals",
    ],
    boxTitle: "Despite all this effort…",
    boxBody: "You keep working harder, but your money doesn't work for you. Every year feels the same, and real financial freedom feels far away.",
  },
  {
    key: "after",
    title: "AFTER This Masterclass",
    head: "bg-gradient-to-r from-green-600 to-green-500",
    bg: "bg-green-50/70",
    box: "border-green-400",
    Icon: CheckCircle2,
    icon: "text-green-600",
    items: [
      "You'll know exactly where your money is going",
      "You'll have a clear order to fix your finances",
      "You'll understand how wealthy families think about money",
      "You'll leave with a simple next step for your family's future",
    ],
    boxTitle: "That's when things start to shift.",
    boxBody: "Money stops feeling stressful. You know what to focus on, what to ignore, and how to move forward with clarity.",
  },
];

export const Expect = () => (
  <section className="px-4 py-14 sm:py-20 bg-white" data-testid="expect-section">
    <div className="max-w-5xl mx-auto">
      <Reveal>
        <SectionTitle>Here's <Highlight>What To Expect</Highlight> From The Wealth Code Masterclass</SectionTitle>
      </Reveal>
      <div className="grid md:grid-cols-2 gap-5 mt-8">
        {COLS.map((c, i) => (
          <Reveal key={c.key} delay={i * 0.1} className={`rounded-2xl overflow-hidden ${c.bg} border border-zinc-100`} data-testid={`expect-${c.key}`}>
            <h3 className={`${c.head} text-white font-extrabold px-5 py-3 text-[15px] sm:text-base`}>{c.title}</h3>
            <div className="p-5">
              <ul className="space-y-2.5">
                {c.items.map((t) => (
                  <li key={t} className="flex gap-2.5 text-[13.5px] sm:text-sm text-zinc-800"><c.Icon className={`w-[18px] h-[18px] shrink-0 mt-px ${c.icon}`} />{t}</li>
                ))}
              </ul>
              <div className={`mt-5 rounded-xl bg-white border-2 border-dashed ${c.box} p-4`}>
                <p className="font-bold text-ink text-sm">{c.boxTitle}</p>
                <p className="text-[13.5px] text-zinc-700 mt-1.5 leading-relaxed">{c.boxBody}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
